import {ChangeDetectionStrategy, Component, Input} from '@angular/core';
import { NgClass, NgStyle } from '@angular/common';

@Component({
    selector: 'progressbar',
    templateUrl: 'progressbar.component.html',
    imports: [NgClass, NgStyle],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class ProgressBarComponent {
  // Input parameters
  @Input() value: number;
  // eslint-disable-next-line @angular-eslint/no-input-rename
  @Input('color') bgColor: string;
  @Input() label: string;

  active = false;

  get width(): string {
    return (this.value ?? 0) + '%';
  }

  activate(isActive: boolean) {
    this.active = isActive;
  }
}
